<template>
  <section class="show-layout">
    <v-toolbar class="green header" fixed dark>
      <slot name="header" />
    </v-toolbar>

    <v-container>
      <v-layout row>
        <v-flex md8>
          <main class="content">
            <slot name="content" />
          </main>
        </v-flex>
        <v-flex md4>
          <aside class="ml-5 sidebar">
            <slot name="sidebar" />
          </aside>
        </v-flex>
      </v-layout>
    </v-container>
    <contact-component/>
  </section>
</template>

<script>
import ImaLogo from '@/components/base/ImaLogo';
import ContactComponent from '@/components/ContactComponent';
import NavigationHeader from '@/components/base/NavigationHeader';
import NotificationDropdown from '@/components/base/NotificationDropdown';
import AccountDropdown from '@/components/base/AccountDropdown';

export default {
  name: 'InLayout',
  components: {
    ImaLogo,
    NavigationHeader,
    ContactComponent,
    NotificationDropdown,
    AccountDropdown,
  },
};
</script>

<style lang="scss">
  .show-layout {
    & {
      padding-top: 74px;
    }

    .content {
      .file-btn input[type=file] {
        display: none;
      }

      .document-list {
        .v-list__tile {
          height: auto;
        }
      }
      .document-item {
        padding: 1rem 0;
        width: 100%;
      }
    }
    .application-sidebar {
      .solicitante{
        font-size: 14px;
        text-transform: capitalize;
      }
    }
    .content,
    .sidebar {
      .subheader-1{
        margin-left: -15px;
        font-size: 12px;
        font-family: Avenir, Open Sans, Helvetica, Arial, sans-serif;
        text-transform: uppercase;
      }

      .subheader-2{
        font-size: 15px;
        font-family: Avenir, Open Sans, Helvetica, Arial, sans-serif;
      }
    }
  }
</style>
